const messages = {
  "title": "Velkommen til BRIDGESTONE <span class='text-danger'>PLUS</span>",
  "description": "<b>Har du allerede en konto?</b><br/>Logg inn med e-postadressen og passordet ditt.<br/><br/><b>Ny her?</b><br/>Hvis du er ny bruker, vennligst registrer deg.<br/><br/>",
  "info": "",
  "buttons": {
    "action": "Logg inn / Registrer",
    "back": "Tilbake til innlogging",
    "changeLanguage": "Bytt språk",
    "start": "Start"
  },
  "languageSelect": {
    "label": "Språkvalg",
    "description": "Vennligst velg ditt språk",
    "start": {
      "nnNO": "Start",
      "nbNO": "Start",
      "noNO": "Start"
    }
  }
}

export default {
  messages
}
